<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-button content="tab.conveyorConfig" mode="text" status="primary"/>
      </template>
      <template #extra>
        <vxe-button content="button.refresh" icon="vxe-icon-refresh" mode="text" status="danger" @click="refresh(warehouse)"/>
        <vxe-button content="button.add" icon="vxe-icon-add" mode="text" status="primary" @click="add"/>
      </template>
      <vxe-table ref="table" :data="list" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="conveyor.no" title="business.label.conveyor"/>
        <vxe-column field="startPosition" title="business.label.sourcePosition"/>
        <vxe-column field="endPosition" title="business.label.targetPosition"/>
        <vxe-column field="pickupMode.name" title="business.label.pickupMode"/>
        <vxe-column field="direction.name" title="business.label.direction"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="edit(row,false)"/>
            <vxe-button content="button.copy" icon="vxe-icon-copy" status="primary" @click.stop="edit(row,true)"/>
            <vxe-button content="button.delete" icon="vxe-icon-delete" status="danger" @click.stop="remove(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
    </vxe-card>
    <vxe-modal v-model="visible" :loading="loading" :title="$t('tab.conveyorConfig')" type="confirm" width="30%" @confirm="confirm">
      <vxe-form ref="form" :data="config" :rules="rules" span="12">
        <vxe-form-item :item-render="{name:'VxeSelect',options:conveyors,events:{change:()=>onConveyorChange}}" field="conveyor.id" span="24" title="business.label.conveyor"/>
        <vxe-form-item :item-render="{name:'VxeInput'}" field="startPosition" title="business.label.sourcePosition"/>
        <vxe-form-item :item-render="{name:'VxeInput'}" field="endPosition" title="business.label.targetPosition"/>
        <vxe-form-item :item-render="{name:'VxeSelect',options:pickupModes,events:{change:()=>onPickupModeChange}}" field="pickupMode.id" title="business.label.pickupMode"/>
        <vxe-form-item :item-render="{name:'VxeSelect',options:directions,events:{change:()=>onDirectionChange}}" field="direction.id" title="business.label.direction"/>
      </vxe-form>
    </vxe-modal>
  </div>
</template>

<script>
import { deleteOne, findAll, findOne, save } from '@/api/Api'
import { Warehouse } from '@/api/dto/common/Warehouse'
import { ConveyorConfig } from '@/api/dto/config/ConveyorConfig'
import { Dictionary } from '@/api/dto/admin/Dictionary'

export default {
  props: {
    conveyors: { type: Array, default: [] },
    pickupModes: { type: Array, default: [] },
    directions: { type: Array, default: [] }
  },
  data() {
    return {
      loading: false,
      visible: false,
      warehouse: new Warehouse(),
      list: [],
      config: new ConveyorConfig(),
      rules: {
        'conveyor.id': [{ required: true, message: this.$t('message.cannotBeEmpty') }]
      }
    }
  },
  methods: {
    onConveyorChange(event) {
      this.config.conveyor = new Dictionary({ id: event.value })
    },
    onPickupModeChange(event) {
      this.config.pickupMode = new Dictionary({ id: event.value })
    },
    onDirectionChange(event) {
      this.config.direction = new Dictionary({ id: event.value })
    },
    refresh(warehouse) {
      this.warehouse = warehouse
      if (this.warehouse.isNew()) {
        return this.$message.warning('请先选择仓库')
      }
      this.loading = true
      findAll('conveyorConfigFactory', { 'warehouse.id': this.warehouse.id }).then(res => {
        if (res.success) {
          this.list = res.result.map(item => {
            return new ConveyorConfig(item)
          })
        }
      }).finally(() => this.loading = false)
    },
    add() {
      this.visible = true
      this.config = new ConveyorConfig()
    },
    edit(row, copy) {
      this.visible = true
      this.loading = true
      findOne('conveyorConfigFactory', { id: row.id }).then(res => {
        if (res.success) {
          if (copy) {
            res.result.id = undefined
            res.result.version = undefined
          }
          this.config = new ConveyorConfig(res.result)
        }
      }).finally(() => this.loading = false)
    },
    save() {
      this.loading = true
      const config = this.config.toJSONObject()
      config.warehouse = this.warehouse
      save('conveyorConfigPersister', config).then(res => {
        if (res.success) {
          this.config = new ConveyorConfig(res.result)
          this.$message.success(this.$t('message.saveSuccess'))
          this.refresh(this.warehouse)
          this.visible = false
        }
      }).finally(() => this.loading = false)
    },
    async confirm() {
      if (!await this.$refs.form.validate()) this.save()
    },
    remove(row) {
      if (row.id) {
        this.loading = true
        deleteOne('conveyorConfigDeleter', { id: row.id }).then(res => {
          if (res.success) {
            this.refresh(this.warehouse)
            this.$message.success(this.$t('message.deleteSuccess'))
          }
        }).finally(() => this.loading = false)
      } else {
        this.list.splice(this.list.indexOf(row), 1)
      }
    }
  }
}
</script>